import { isDeletedTimelineEntry } from "../../services/timeline/deletionRules";
import { dedupeTimelineEntries } from "../../services/timeline/timelineDeduping";
import { isCanonicalStoryMomentEntry } from "../../components/Timeline/utils/storyMomentEligibility";
import { timestampToMillis } from "./careSourceStatusModel";
export const getSourceResultEntryDate = (entry = {}) =>
  entry.localDate ||
  entry.entryDate ||
  entry.date ||
  entry.timestamp ||
  entry.createdAt ||
  null;

export const normalizeSourceResultEntries = (entries = []) =>
  dedupeTimelineEntries(
    entries.filter(
      (entry) =>
        Boolean(entry) &&
        !isDeletedTimelineEntry(entry) &&
        entry.kind !== "story_moment_reference" &&
        entry.pointerKind !== "story_moment_reference" &&
        isCanonicalStoryMomentEntry({
          ...entry,
          collection: entry.collection || "dailyLogs",
        }),
    ),
  ).sort(
    (a, b) =>
      timestampToMillis(getSourceResultEntryDate(a)) -
      timestampToMillis(getSourceResultEntryDate(b)),
  );
